import ElCarouselItem from '../carousel/src/item';
import '@/theme/css/basic/carousel-item.scss';

/* istanbul ignore next */
// ElCarouselItem.install = function(Vue) {
//   Vue.component(ElCarouselItem.name, ElCarouselItem);
// };

export default ElCarouselItem;